export default {
  //
  login: "",
  signup: "/signup",
  user_update: "/modifyAccout",
  user_info: "/userinfo",

  action_like: "/like",
  action_unlike: "/unlike",

  //
  list_asset: "/all_assert",
  list_asset_search: "/search",

  list_asset_suit: "/searchNFTAddress",

  //
  query_item_meme: "@get:https://api.dontbuymeme.com/memes/:id",
  query_item_detail: "/nft_detail",
  query_item_history: "/nft_history",
  query_item_creator: "/nftCreator",

  //
  list_site_history: "/nft_all_history",

  // actions
  sell: "/sell",

  // bid相关
  bid: "/bid",
  list_item_bid_history: "/bid_history",

  //
  list_asset_my_sell: "/my_assert_onsale",
  list_asset_my: "/my_assert",
  list_asset_my_like: "/like_list",
  list_my_history: "/nft_my_history",

  // create
  create_item_single: "/creatNFT721",
  create_item_multi: "/creatNFT1155"
};